import React from 'react';
import DonutChartCard from './DonutChartCard';
import ProgressBar from '../Input/ProgressBar';
import CommonProgressBar from '../Input/CommonProgressBar';
import { SelfAssessmentPageData } from '../../../utils/experienceConstants';

const ValueCards = ({ resultData, isDashboard = false, time = 'Morning' }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [isOpen2, setIsOpen2] = React.useState(false);
  const [option, setOption] = React.useState(0);
  const [option2, setOption2] = React.useState(0);
  const completePercentage =
    (
      (resultData?.assessment?.completedCount ? resultData?.assessment?.completedCount : 0 * 100) /
      resultData?.assessment?.total
    )?.toFixed(1) === 'NaN'
      ? 0
      : (
          ((resultData?.assessment?.completedCount ? resultData?.assessment?.completedCount : 0) *
            100) /
          resultData?.assessment?.total
        )?.toFixed(1);

  const incompletedPercentage =
    (
      (resultData?.assessment?.inCompletedCount
        ? resultData?.assessment?.inCompletedCount
        : 0 * 100) / resultData?.assessment?.total
    )?.toFixed(1) === 'NaN'
      ? 0
      : (
          ((resultData?.assessment?.inCompletedCount
            ? resultData?.assessment?.inCompletedCount
            : 0) *
            100) /
          resultData?.assessment?.total
        )?.toFixed(1);

  const totalCompleteAssesment = resultData?.assessment?.completedCount
    ? resultData?.assessment?.completedCount
    : 0;
  const CompletedData = [
    {
      label: SelfAssessmentPageData.assessmentCardSection.cardTwo.resultLabelOne,
      value: resultData?.assessment?.completedCount ? resultData?.assessment?.completedCount : 0,
      percentage: completePercentage,
      color: '#D97F56'
    },
    {
      label: SelfAssessmentPageData.assessmentCardSection.cardTwo.resultLabelTwo,
      value: resultData?.assessment?.inCompletedCount
        ? resultData?.assessment?.inCompletedCount
        : 0,
      percentage: incompletedPercentage,
      color: '#ECC09E'
    }
  ];

  const ageEngagements = resultData?.ageRangeEngagement;

  const options = [
    {
      label: 'Age 0-25',
      value: ageEngagements?.[0]?.count + ageEngagements?.[1]?.count || 0,
      color: '#67A14A'
    },
    {
      label: 'Age 26-50',
      value: ageEngagements?.[2]?.count + ageEngagements?.[3]?.count || 0,
      color: '#D97F56'
    },
    {
      label: 'Age 51+',
      value: ageEngagements?.[4]?.count ? ageEngagements?.[2]?.count : 0,
      color: '#ECC09E'
    }
  ];
  const totalAgeEngagements = resultData?.totalUserCount;
  const ageEngagementsFristPercentage =
    ((ageEngagements?.[0]?.count * 100) / totalAgeEngagements)?.toFixed(1) === 'NaN'
      ? 0
      : ((ageEngagements?.[0]?.count * 100) / totalAgeEngagements)?.toFixed(1);
  const ageEngagementsThreePercentage =
    ((ageEngagements?.[2]?.count * 100) / totalAgeEngagements)?.toFixed(1) === 'NaN'
      ? 0
      : ((ageEngagements?.[2]?.count * 100) / totalAgeEngagements)?.toFixed(1);
  const ageEngagementsFourPercentage =
    ((ageEngagements?.[3]?.count * 100) / totalAgeEngagements)?.toFixed(1) === 'NaN'
      ? 0
      : ((ageEngagements?.[3]?.count * 100) / totalAgeEngagements)?.toFixed(1);
  const ageEngagementsFivePercentage =
    ((ageEngagements?.[4]?.count * 100) / totalAgeEngagements)?.toFixed(1) === 'NaN'
      ? 0
      : ((ageEngagements?.[4]?.count * 100) / totalAgeEngagements)?.toFixed(1);
  const ageEngagementsSixPercentage =
    ((ageEngagements?.[5]?.count * 100) / totalAgeEngagements)?.toFixed(1) === 'NaN'
      ? 0
      : ((ageEngagements?.[5]?.count * 100) / totalAgeEngagements)?.toFixed(1);

  const ageEngagementsSecondPercentage =
    (
      (ageEngagements?.[1]?.count * 100) /
      (totalAgeEngagements !== 0 ? totalAgeEngagements : 1)
    )?.toFixed(1) === 'NaN'
      ? 0
      : (
          (ageEngagements?.[1]?.count * 100) /
          (totalAgeEngagements !== 0 ? totalAgeEngagements : 1)
        )?.toFixed(1);
  const UserAgeRangeData1 = [
    {
      label: 'Age 0-18',
      value: ageEngagements?.[0]?.count ? ageEngagements?.[0]?.count : 0,
      percentage: ageEngagementsFristPercentage,
      color: '#67A14A'
    },
    {
      label: 'Age 19-25',
      value: ageEngagements?.[1]?.count ? ageEngagements?.[1]?.count : 0,
      percentage: ageEngagementsSecondPercentage,
      color: '#C2EC97'
    }
  ];
  const UserAgeRangeData2 = [
    {
      label: 'Age 26-32',
      value: ageEngagements?.[2]?.count ? ageEngagements?.[2]?.count : 0,
      percentage: ageEngagementsThreePercentage,
      color: '#67A14A'
    },
    {
      label: 'Age 33-50',
      value: ageEngagements?.[3]?.count ? ageEngagements?.[3]?.count : 0,
      percentage: ageEngagementsFourPercentage,
      color: '#C2EC97'
    }
  ];
  const UserAgeRangeData3 = [
    {
      label: 'Age 51+',
      value: ageEngagements?.[4]?.count ? ageEngagements?.[4]?.count : 0,
      percentage: ageEngagementsFivePercentage,
      color: '#67A14A'
    },
    {
      label: 'Other',
      value: ageEngagements?.[5]?.count ? ageEngagements?.[5]?.count : 0,
      percentage: ageEngagementsSixPercentage,
      color: '#C2EC97'
    }
  ];
  const UserAgeRangeData =
    option === 0 ? UserAgeRangeData1 : option === 1 ? UserAgeRangeData2 : UserAgeRangeData3;

  // const CommonOutComeData = [
  //   {
  //     label: 'Attachment',
  //     value: resultData?.outComeType?.[0]?.types?.[1]?.count
  //       ? resultData?.outComeType?.[0]?.types?.[1]?.count
  //       : 0,
  //     percentage: resultData?.outComeType?.[0].types?.[1]?.percentage?.toFixed(1)
  //       ? resultData?.outComeType?.[0].types?.[1]?.percentage?.toFixed(1)
  //       : 0,
  //     color: '#ec4899'
  //   },
  //   {
  //     label: 'Percentage',
  //     value: resultData?.outComeType?.[0]?.types?.[0]?.count
  //       ? resultData?.outComeType?.[0]?.types?.[0]?.count
  //       : 0,
  //     percentage: resultData?.outComeType?.[0].types?.[0]?.percentage?.toFixed(1)
  //       ? resultData?.outComeType?.[0].types?.[0]?.percentage?.toFixed(1)
  //       : 0,
  //     color: '#f9a8d4'
  //   }
  // ];

  const totalTimeEngagements = resultData?.engagementRates?.find(
    (item) => item?.timeRange === time
  )?.totalEngagements;
  const TopUsageTimesData =
    time === SelfAssessmentPageData.assessmentCardSection.cardThree.resultAlternativeOne
      ? [
          {
            label: resultData?.engagementRates?.[0]?.timeRange,
            value: resultData?.engagementRates?.[0]?.totalEngagements
              ? resultData?.engagementRates?.[0]?.totalEngagements?.toFixed(1)
              : 0,
            percentage: resultData?.engagementRates?.[0]?.engagementRatePercentage?.toFixed(1)
              ? resultData?.engagementRates?.[0]?.engagementRatePercentage?.toFixed(1)
              : 0,
            color: '#21BDAD'
          }
        ]
      : time === SelfAssessmentPageData.assessmentCardSection.cardThree.resultAlternativeTwo
      ? [
          {
            label: resultData?.engagementRates?.[1]?.timeRange,
            value: resultData?.engagementRates?.[1]?.totalEngagements
              ? resultData?.engagementRates?.[1]?.totalEngagements?.toFixed(1)
              : 0,
            percentage: resultData?.engagementRates?.[1]?.engagementRatePercentage?.toFixed(1)
              ? resultData?.engagementRates?.[1]?.engagementRatePercentage?.toFixed(1)
              : 0,
            color: '#6BE0BD'
          }
        ]
      : [
          {
            label: resultData?.engagementRates?.[2]?.timeRange,
            value: resultData?.engagementRates?.[2]?.totalEngagements
              ? resultData?.engagementRates?.[2]?.totalEngagements?.toFixed(1)
              : 0,
            percentage: resultData?.engagementRates?.[2]?.engagementRatePercentage?.toFixed(1)
              ? resultData?.engagementRates?.[2]?.engagementRatePercentage?.toFixed(1)
              : 0,
            color: '#21BDAD'
          }
        ];

  const options2 = [
    {
      label: '10-30',
      value: resultData?.scoreRanges?.[0]?.count + resultData?.scoreRanges?.[1]?.count || 0,
      color: '#67A14A'
    },
    {
      label: '30-60',
      value: resultData?.scoreRanges?.[2]?.count + resultData?.scoreRanges?.[3]?.count || 0,
      color: '#D97F56'
    },
    {
      label: '60-80',
      value: resultData?.scoreRanges?.[4]?.count + resultData?.scoreRanges?.[5]?.count || 0,
      color: '#67A14A'
    },
    {
      label: '80-100',
      value: resultData?.scoreRanges?.[6]?.count + resultData?.scoreRanges?.[7]?.count || 0,
      color: '#D97F56'
    }
  ];

  const AverageScoresData1 = [
    {
      label: resultData?.scoreRanges?.[0]?._id,
      value: resultData?.scoreRanges?.[0]?.percentage
        ? resultData?.scoreRanges?.[0]?.percentage?.toFixed(1)
        : 0,
      percentage:
        resultData?.scoreRanges?.[0]?.percentage?.toFixed(2) === 'NaN'
          ? 0
          : resultData?.scoreRanges?.[0]?.percentage?.toFixed(2),
      color: '#EDCC12'
    },
    {
      label: resultData?.scoreRanges?.[1]?._id,
      value: resultData?.scoreRanges?.[1]?.percentage
        ? resultData?.scoreRanges?.[1]?.percentage?.toFixed(1)
        : 0,
      percentage:
        resultData?.scoreRanges?.[1]?.percentage?.toFixed(2) === 'NaN'
          ? 0
          : resultData?.scoreRanges?.[1]?.percentage?.toFixed(2),
      color: '#FFE873'
    }
  ];

  const AverageScoresData2 = [
    {
      label: resultData?.scoreRanges?.[2]?._id,
      value: resultData?.scoreRanges?.[2]?.percentage
        ? resultData?.scoreRanges?.[2]?.percentage?.toFixed(1)
        : 0,
      percentage:
        resultData?.scoreRanges?.[2]?.percentage?.toFixed(2) === 'NaN'
          ? 0
          : resultData?.scoreRanges?.[2]?.percentage?.toFixed(2),
      color: '#EDCC12'
    },
    {
      label: resultData?.scoreRanges?.[3]?._id,
      value: resultData?.scoreRanges?.[3]?.percentage
        ? resultData?.scoreRanges?.[3]?.percentage?.toFixed(1)
        : 0,
      percentage:
        resultData?.scoreRanges?.[3]?.percentage?.toFixed(2) === 'NaN'
          ? 0
          : resultData?.scoreRanges?.[3]?.percentage?.toFixed(2),
      color: '#FFE873'
    }
  ];

  const AverageScoresData3 = [
    {
      label: resultData?.scoreRanges?.[4]?._id,
      value: resultData?.scoreRanges?.[4]?.percentage
        ? resultData?.scoreRanges?.[4]?.percentage?.toFixed(1)
        : 0,
      percentage:
        resultData?.scoreRanges?.[4]?.percentage?.toFixed(2) === 'NaN'
          ? 0
          : resultData?.scoreRanges?.[4]?.percentage?.toFixed(2),
      color: '#EDCC12'
    },
    {
      label: resultData?.scoreRanges?.[5]?._id,
      value: resultData?.scoreRanges?.[5]?.percentage
        ? resultData?.scoreRanges?.[5]?.percentage?.toFixed(1)
        : 0,
      percentage:
        resultData?.scoreRanges?.[5]?.percentage?.toFixed(2) === 'NaN'
          ? 0
          : resultData?.scoreRanges?.[5]?.percentage?.toFixed(2),
      color: '#FFE873'
    }
  ];

  const AverageScoresData4 = [
    {
      label: resultData?.scoreRanges?.[6]?._id,
      value: resultData?.scoreRanges?.[6]?.percentage
        ? resultData?.scoreRanges?.[6]?.percentage?.toFixed(1)
        : 0,
      percentage:
        resultData?.scoreRanges?.[6]?.percentage?.toFixed(2) === 'NaN'
          ? 0
          : resultData?.scoreRanges?.[6]?.percentage?.toFixed(2),
      color: '#EDCC12'
    },
    {
      label: resultData?.scoreRanges?.[7]?._id,
      value: resultData?.scoreRanges?.[7]?.percentage
        ? resultData?.scoreRanges?.[7]?.percentage?.toFixed(1)
        : 0,
      percentage:
        resultData?.scoreRanges?.[7]?.percentage?.toFixed(2) === 'NaN'
          ? 0
          : resultData?.scoreRanges?.[7]?.percentage?.toFixed(2),
      color: '#FFE873'
    }
  ];

  const totalScores = resultData?.averageScore;
  const AverageScoresData =
    option2 === 0
      ? AverageScoresData1
      : option2 === 1
      ? AverageScoresData2
      : option2 === 2
      ? AverageScoresData3
      : AverageScoresData4;

  const selfAssesmentDashboard = [
    {
      component: (
        <div className="md:p-6 p-4 w-full sm:mb-0 lg:w-2/5 min-w-full gap-2 sm:min-w-[202px] bg-[#FFFFFF] rounded-xl border border-[#E7E8EA]">
          <h2
            className={`lg:text-[20px] text-[18px] font-medium text-[#0B0F18] text-left dark:text-shoorah-darkBg mb-5`}
          >
            {SelfAssessmentPageData.assessmentCardSection.cardOne.title}
          </h2>
          <div className={`grid grid-cols-1 gap-2`}>
            {resultData?.outCome?.length > 0 ? (
              resultData?.outCome?.map((item, index) => (
                <div
                  key={index}
                  title={item?.title}
                  className="border-[1.5px] border-shoorah-borderLight rounded-[10px] px-4 py-[11px] flex items-center md:gap-6 gap-4"
                >
                  <span className="md:text-[16px] text-[14px] leading-5 text-[#606060] md:w-[calc(100%-100px)] w-[calc(100%-80px)] line-clamp-1">
                    {item?.title}
                  </span>
                  <div className="md:w-[100px] w-[80px]">
                    <CommonProgressBar percentage={item?.percentage} />
                  </div>
                </div>
              ))
            ) : (
              <div className="w-full h-full flex items-center justify-center mt-[65px]">
                {SelfAssessmentPageData.assessmentCardSection.cardOne.notFound}
              </div>
            )}
          </div>
        </div>
      )
    },
    {
      component: (
        <DonutChartCard
          data={CompletedData}
          totalAgeEngagements={totalCompleteAssesment}
          title={SelfAssessmentPageData.assessmentCardSection.cardTwo.title}
        />
      )
    },
    // {
    //   component: (
    //     <DonutChartCard
    //       data={UserAgeRangeData}
    //       title={'User Age Range'}
    //       totalAgeEngagements={totalAgeEngagements}
    //       options={options}
    //       open={isOpen}
    //       option={option}
    //       setOption={setOption}
    //       setOpen={setIsOpen}
    //       range={true}
    //     />
    //   )
    // },
    // {
    //   component: <DonutChartCard data={CommonOutComeData} title={'Common Outcome'} />
    // },
    {
      component: (
        <DonutChartCard
          data={TopUsageTimesData}
          title={SelfAssessmentPageData.assessmentCardSection.cardThree.title}
          totalAgeEngagements={totalTimeEngagements}
        />
      )
    },
    {
      component: (
        <DonutChartCard
          data={AverageScoresData}
          totalAgeEngagements={totalScores}
          title={SelfAssessmentPageData.assessmentCardSection.cardFour.title}
          options={options2}
          open={isOpen2}
          option={option2}
          setOption={setOption2}
          setOpen={setIsOpen2}
          range={true}
        />
      )
    }
  ];

  // Self Assessment Result

  const UserCompletedData = [
    {
      label: 'Complete',
      value: resultData?.assessment?.completedPercentage
        ? resultData?.assessment?.completedPercentage
        : 0,
      percentage: resultData?.assessment?.completedPercentage
        ? resultData?.assessment?.completedPercentage
        : 0,
      color: '#D97F56'
    },
    {
      label: 'Incomplete',
      value: resultData?.assessment?.incompletedPercentage
        ? resultData?.assessment?.incompletedPercentage
        : 0,
      percentage: resultData?.assessment?.incompletedPercentage
        ? resultData?.assessment?.incompletedPercentage
        : 0,
      color: '#ECC09E'
    }
  ];

  const ageEngagementsResult = resultData?.ageRangeEngagementResultCounts;

  const totalAgeEngagementsResult = resultData?.totalUserCount;

  const UserAgeRangeResultData1 = [
    {
      label: 'Age 0-18',
      value: ageEngagementsResult?.[0]?.count || 0,
      percentage:
        (
          (ageEngagementsResult?.[0]?.count * 100) /
          (totalAgeEngagementsResult !== 0 ? totalAgeEngagementsResult : 1)
        )?.toFixed(1) === 'NaN'
          ? 0
          : (
              (ageEngagementsResult?.[0]?.count * 100) /
              (totalAgeEngagementsResult !== 0 ? totalAgeEngagementsResult : 1)
            )?.toFixed(1),
      color: '#67A14A'
    },
    {
      label: 'Age 19-25',
      value: ageEngagementsResult?.[1]?.count || 0,
      percentage:
        (
          (ageEngagementsResult?.[1]?.count * 100) /
          (totalAgeEngagementsResult !== 0 ? totalAgeEngagementsResult : 1)
        )?.toFixed(1) === 'NaN'
          ? 0
          : (
              (ageEngagementsResult?.[1]?.count * 100) /
              (totalAgeEngagementsResult !== 0 ? totalAgeEngagementsResult : 1)
            )?.toFixed(1),
      color: '#C2EC97'
    }
  ];
  const UserAgeRangeResultData2 = [
    {
      label: 'Age 26-32',
      value: ageEngagementsResult?.[2]?.count,
      percentage:
        (
          (ageEngagementsResult?.[2]?.count * 100) /
          (totalAgeEngagementsResult !== 0 ? totalAgeEngagementsResult : 1)
        )?.toFixed(1) === 'NaN'
          ? 0
          : (
              (ageEngagementsResult?.[2]?.count * 100) /
              (totalAgeEngagementsResult !== 0 ? totalAgeEngagementsResult : 1)
            )?.toFixed(1),
      color: '#67A14A'
    },
    {
      label: 'Age 33-50',
      value: ageEngagementsResult?.[3]?.count,
      percentage:
        (
          (ageEngagementsResult?.[3]?.count * 100) /
          (totalAgeEngagementsResult !== 0 ? totalAgeEngagementsResult : 1)
        )?.toFixed(1) === 'NaN'
          ? 0
          : (
              (ageEngagementsResult?.[3]?.count * 100) /
              (totalAgeEngagementsResult !== 0 ? totalAgeEngagementsResult : 1)
            )?.toFixed(1),
      color: '#C2EC97'
    }
  ];
  const UserAgeRangeResultData3 = [
    {
      label: 'Age 51+',
      value: ageEngagementsResult?.[4]?.count,
      percentage:
        (
          (ageEngagementsResult?.[4]?.count * 100) /
          (totalAgeEngagementsResult !== 0 ? totalAgeEngagementsResult : 1)
        )?.toFixed(1) === 'NaN'
          ? 0
          : (
              (ageEngagementsResult?.[4]?.count * 100) /
              (totalAgeEngagementsResult !== 0 ? totalAgeEngagementsResult : 1)
            )?.toFixed(1),
      color: '#67A14A'
    },
    {
      label: 'Other',
      value: ageEngagementsResult?.[5]?.count,
      percentage:
        (
          (ageEngagementsResult?.[5]?.count * 100) /
          (totalAgeEngagementsResult !== 0 ? totalAgeEngagementsResult : 1)
        )?.toFixed(1) === 'NaN'
          ? 0
          : (
              (ageEngagementsResult?.[5]?.count * 100) /
              (totalAgeEngagementsResult !== 0 ? totalAgeEngagementsResult : 1)
            )?.toFixed(1),
      color: '#C2EC97'
    }
  ];

  const UserAgeRangeResultData =
    option === 0
      ? UserAgeRangeResultData1
      : option === 1
      ? UserAgeRangeResultData2
      : UserAgeRangeResultData3;

  const UserOutComeData = [
    {
      label: 'Positive',
      value: parseInt(resultData?.outCome?.positive?.replace('%', '')),
      percentage: resultData?.outCome?.positive
        ? resultData?.outCome?.positive?.replace('%', '')
        : 0,
      color: '#ec4899'
    },
    {
      label: 'Negative',
      value: parseInt(resultData?.outCome?.negative?.replace('%', '')),
      percentage: resultData?.outCome?.positive
        ? resultData?.outCome?.positive?.replace('%', '')
        : 0,
      color: '#f9a8d4'
    }
  ];

  const UserTopUsageTimesData = [
    {
      label: '7-8am',
      value: resultData?.usageTime?.['7-8am_percentage']?.toFixed(2),
      percentage: resultData?.usageTime?.['7-8am_percentage']
        ? resultData?.usageTime?.['7-8am_percentage']?.toFixed(2)
        : 0,
      color: '#21BDAD'
    },
    {
      label: '9-10pm',
      value: resultData?.usageTime?.['9-10pm_percentage']?.toFixed(2),
      percentage: resultData?.usageTime?.['9-10pm_percentage']
        ? resultData?.usageTime?.['9-10pm_percentage']?.toFixed(2)
        : 0,
      color: '#6BE0BD'
    }
  ];

  const totalScores2 = resultData?.averageScore;

  const UserAvrageScoresData =
    option2 === 0 ? AverageScoresData1 : option2 === 1 ? AverageScoresData2 : AverageScoresData3;

  const selfAssesmentResult = [
    {
      component: (
        <DonutChartCard data={UserCompletedData} isTotal={true} title={'Users Completed'} />
      )
    },
    {
      component: (
        <DonutChartCard
          data={UserAgeRangeResultData}
          isTotal={true}
          title={'User Age Range'}
          totalAgeEngagements={totalAgeEngagementsResult}
          options={options}
          open={isOpen}
          option={option}
          setOption={setOption}
          setOpen={setIsOpen}
          range={true}
        />
      )
    },
    {
      component: (
        <DonutChartCard data={UserOutComeData} isTotal={true} title={'Outcome Percentage'} />
      )
    },
    {
      component: (
        <DonutChartCard data={UserTopUsageTimesData} isTotal={true} title={'Top Usage Times'} />
      )
    },
    {
      component: (
        <DonutChartCard
          data={UserAvrageScoresData}
          isTotal={true}
          title={'Average Scores'}
          options={options2}
          totalAgeEngagements={totalScores2}
          open={isOpen2}
          option={option2}
          setOption={setOption2}
          setOpen={setIsOpen2}
          range={true}
        />
      )
    }
  ];

  const dataList = isDashboard ? selfAssesmentDashboard : selfAssesmentResult;

  return (
    <div className="flex flex-col sm:flex-row gap-4 w-full">
      <div className="flex flex-col lg:flex-row md:flex-col gap-10 pb-[10px] w-full overflow-x-auto horizontal-card-scrollbar">
        <div className="flex flex-col md:flex md:flex-row gap-4 md:gap-5 w-full">
          {dataList.map((item, index) => (
            <React.Fragment key={index}>{item.component}</React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ValueCards;
